import React from 'react'
import SectionContainer from '../../../Homepage/SectionContainer'
import BreadCrumb from '../../../component/BreadCrumb/BreadCrumb'
import { useParams } from 'react-router-dom'
import PrivacyService from '../../../services/Privacy'
import { useQuery } from '@tanstack/react-query'
import '../privacy.css'
import { Col, Row } from 'reactstrap'

const Privacy = () => {
  const { id } = useParams();

  const fetchData = async () => {
    const encodedId = encodeURIComponent(id);
    return await PrivacyService.getbyslug(encodedId);
  };

  const { isLoading, error, data } = useQuery({
    queryKey: ["privacy", id],
    queryFn: fetchData,
    enabled: !!id,
  });


  const renderContent = (htmlContent) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlContent;

    return Array.from(tempDiv.children).map((child, index) => {
      if (child.tagName === "H1" || child.tagName === "H2" || child.tagName === "H3") {
        const HeadingTag = child.tagName.toLowerCase();
        return (
          <Row key={index} className="my-3">
            <Col>
              <HeadingTag className="font-level-7 m-0">{child.textContent}</HeadingTag>
            </Col>
          </Row>
        );
      }

      if (child.tagName === "P" && child.textContent.trim()) {
        return (
          <Row key={index}>
            <Col>
              <p
                className="country-paragraph-text m-0"
                dangerouslySetInnerHTML={{
                  __html: child.innerHTML,
                }}
              />
            </Col>
          </Row>
        );
      }

      // Handle unordered lists (UL)
      if (child.tagName === "UL") {
        return (
          <Row key={index}>
            <Col>
              <ul
                className="country-paragraph-text"
                dangerouslySetInnerHTML={{
                  __html: child.innerHTML,
                }}
              />
            </Col>
          </Row>
        );
      }

      // Handle ordered lists (OL)
      if (child.tagName === "OL") {
        return (
          <Row key={index}>
            <Col>
              <ol
                className="country-paragraph-text"
                dangerouslySetInnerHTML={{
                  __html: child.innerHTML,
                }}
              />
            </Col>
          </Row>
        );
      }

      return null;
    });
  };

  return (
    <>
      <div className='privacy-banner'>
        <SectionContainer className="d-flex align-items-center h-100">
          <BreadCrumb items={[
            { title: "HOME", link: "/" },
            { title: "PRIVACY", link: "/privacy" },
          ]} instituition={true} />
          <div className="page-content text-start h-100 d-flex flex-column justify-content-center">
            <h1 className='font-level-4'>{data?.heading}</h1>
          </div>
        </SectionContainer>
      </div>

      <SectionContainer>
        <div style={{ marginBottom: "12rem" }}>
          {data?.content && renderContent(data?.content)}
        </div>
      </SectionContainer>
    </>
  )
}

export default Privacy